
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/models/sql-compilation-errors",
      function () {
        return require("private-next-pages/models/sql-compilation-errors.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/models/sql-compilation-errors"])
      });
    }
  